import React, { useContext, useState } from 'react';
import type { GridApi } from 'ag-grid-community';
import CanvasCard from '../Visualisations/CanvasCard';
import { TopBar } from '../V5Gadget/Matrix';
import DashboardGadgetBottomBar from '../DashboardGadgetBottomBar';
import GqlClientProvider from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/GqlClientProvider';
import RankingMatrixContentContainer from './RankingMatrixContent';
import DashboardGadgetContext from '../../contexts/DashboardGadgetContext';

const RankingMatrixContainer = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.RankingMatrix;
}) => {
  const [gridApi, setGridApi] = useState<GridApi>();
  const [exportHandle, setExportHandle] = useState<DataTable.ExportHandle>();
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      isContentWithoutPadding
      topBar={
        gridApi || exportHandle ? (
          <TopBar
            gridApi={gridApi}
            exportHandle={exportHandle}
            exportName={gadget.name}
            chartDefinition={gadget}
            title={gadget.name}
          />
        ) : undefined
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
      content={
        <GqlClientProvider
          visName={gadget.name}
          visId={gadget.id}
          visType={gadget.type}
        >
          <RankingMatrixContentContainer
            gadget={gadget}
            gridApi={gridApi}
            setGridApi={setGridApi}
            setExportHandle={setExportHandle}
          />
        </GqlClientProvider>
      }
    />
  );
};

export default RankingMatrixContainer;
